import { render, staticRenderFns } from "./KhoTuan.vue?vue&type=template&id=1c615838&scoped=true&"
import script from "./KhoTuan.vue?vue&type=script&lang=js&"
export * from "./KhoTuan.vue?vue&type=script&lang=js&"
import style0 from "./KhoTuan.vue?vue&type=style&index=0&id=1c615838&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c615838",
  null
  
)

export default component.exports